import { createSelector } from 'reselect';
import { Booking, BookingPaymentStatus, BookingSource } from '../../models/booking.model';

const selectBookingState = (state: any) => state.booking;

export const selectBookingsSelector = createSelector(
    selectBookingState,
    (booking) => booking.bookings
);

export const selectBookingLoading = createSelector(
    selectBookingState,
    (booking) => booking.loading
);

export const selectBookingsListParamsSelector = createSelector(
    selectBookingState,
    (booking) => booking.bookingsListParams
);

export const selectBookingsListPageSelector = createSelector(
    selectBookingState,
    (booking) => ({
        page: Number(booking.bookingsListParams.page),
        per_page: Number(booking.bookingsListParams.per_page),
        total: Number(booking.bookingsListParams.total),
        bookings: booking.bookings,
        filteredBookings: booking.bookings.filter((booking: Booking) => 
            !((booking.payment_status === BookingPaymentStatus.PENDING || booking.payment_status === BookingPaymentStatus.FAILED) 
              && (booking.created_source === BookingSource.WEBSITE || booking.booking_from_public_website === true))
        )
    })
);

export const selectImportedBookingsSelector = createSelector(
    selectBookingState,
    (booking) => ({
        importedBookings: booking.importedBookings,
        loading: booking.loading,
        jobStatus: booking.jobStatus
    })
);

export const selectDeleteBookingPaymentLoading = createSelector(
    selectBookingState,
    (booking) => booking.deleteBookingPaymentLoading
);